import { FilterItem } from './filter-item';

export class DividerFilterItem extends FilterItem {
}
